import React from 'react';
import TradingViewWidget, { Themes } from 'react-tradingview-widget';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Mousewheel, Keyboard, EffectCoverflow, Pagination } from 'swiper/modules';
import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'


import { useGameDetails } from 'utils/Hooks';
import CardCurrent from 'components/CardCurrent';
import CardNext from 'components/CardNext';
import CardPrevious from 'components/CardPrevious';
import StoplightCard from 'components/Stoplight';
import { DogeChainDisclaimer } from './disclaimers';
import Metadata from 'components/Metadata';
import 'pages/styles.scss';
import './swiper_custom.scss';
import GameStatus from 'components/GameStatus';

//<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />

SwiperCore.use([Mousewheel, Keyboard, EffectCoverflow, Pagination]);

function PredictionMobile(props) {
  const gameDetails = useGameDetails();

  if (props.newestRoundID == 0)
    return null;
  else
    return (
      <React.Fragment>
        <Metadata
          title={`${gameDetails.tickerSymbol} Price Prediction Game`}
          link='/prediction'
          description={`Predict price movements of ${gameDetails.tickerSymbol} and win crypto if you're correct`}
        />
        <div id='Predict'>
          {/* <PredictionHeadline /> */}
          {/* <SwipingTips /> */}
        </div>
        <div className='PredictionContent Mobile'>
          <GameStatus />
          <Swiper
            init={true}
            effect={'coverflow'}
            mousewheel={true}
            keyboard={{ enabled: true }}
            grabCursor={true}
            centeredSlides={true}
            centerInsufficientSlides={true}
            slidesPerView={"auto"}
            coverflowEffect={{
              rotate: 30,
              stretch: 0,
              depth: 110,
              modifier: 2,
              slideShadows: false,
            }}
            pagination={true}
            className='MainSwiper'
            initialSlide={2}
            noSwipingSelector="input, .ChevronButton" /* no swiping when using any of these */
            resistance={true}
            roundLengths={true}
            speed={100}
          >
            <SwiperSlide className="BaseSlide">
              <CardPrevious
                key={props.newestRoundID - 2}
              />
            </SwiperSlide>
            <SwiperSlide className="BaseSlide">
              <CardCurrent
                key={props.newestRoundID - 1}
                OnLoad={props.OnLoad} // the slowest-loading card; it decides when page is fully loaded
              />
            </SwiperSlide>
            <SwiperSlide className="BaseSlide">
              <CardNext
                key={props.newestRoundID}
              />
            </SwiperSlide>
            <SwiperSlide className='BaseSlide Chart'>
              <div
                className='ChartContainerForSwiper rounded-lg hover:border-gradient-tl-red-yellow gradient-border-3'
              >
                <TradingViewWidget id='TWChart'
                  symbol={"BINANCE:" + gameDetails.tickerSymbol + "USDT"}
                  theme={Themes.DARK}
                  interval="5"
                  locale="en"
                  autosize={true}
                />
              </div>
            </SwiperSlide>

            {/*
          <SwiperSlide className='BaseSlide Chart'>
            <TradingViewWidget
              symbol={"BINANCE:" + gameDetails.tickerSymbol + "USDT"}
              theme={Themes.DARK}
              interval="5"
              locale="en"
              autosize={true}
            />
          </SwiperSlide>
          */}
            <SwiperSlide className='BaseSlide Stoplight'>
              <StoplightCard />
            </SwiperSlide>
          </Swiper>
        </div>
        <DogeChainDisclaimer />
      </React.Fragment>
    );
}

export default PredictionMobile;
